import type { ConfigurationOperation } from '@festina/configuration-general-types/configuration'

import type { ConfigurationItemsByBlock } from '../../workspace/operationsContext'
import type { IndexedOperations, OperationWithSourceInfo } from '../types'

/**
 * The versions of a configuration item that can be transferred off the given block:
 * those defined on the block itself that have neither been annulled nor are still
 * drafts. Draft versions live in a workspace rather than on the block, and annulled
 * ones no longer apply, so neither is carried over to the destination block.
 */
export const getTransferableVersionsInBlock = <
  T extends ConfigurationOperation,
>({
  operationsByBlock,
  block,
  itemId,
}: {
  operationsByBlock: ConfigurationItemsByBlock<IndexedOperations<T>>
  block: string
  itemId: string
}): OperationWithSourceInfo<T>[] =>
  Array.from(operationsByBlock.get(block)?.values() ?? [])
    .flatMap((byItemId) => byItemId.get(itemId)?.operations ?? [])
    .filter(
      ({ annulOperations, isDraft }) => !annulOperations.length && !isDraft,
    )
